export default __webpack_public_path__ + "static/artofQR-4dc9fbb65f05ec24347021723aae04d0.png";